function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';
import config from 'react-global-configuration';
import className from 'classnames';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
import { ApiAutocomplete } from '@uncinc/uncinc-react-kitchen-sink';
import GenericFormElement from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/GenericFormElement';
var WebformAddressAutocomplete = function WebformAddressAutocomplete(props) {
  var entity = props.entity,
    setFieldValue = props.setFieldValue,
    errors = props.errors,
    touched = props.touched;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var API_URL = config.get('API_URL');
  var title = entity.get('#title');
  var webformKey = entity.get('#webform_key');
  var required = entity.get('#required');
  var requiredError = entity.get('#required_error');
  var description = entity.get('#description');
  var fieldOverrides = entity.get('#field_overrides');
  var wrapperClassNames = className('WebformAddress', 'WebformAddressAutocomplete', entity.getIn(['#wrapper_attributes', 'class', 0], ''));
  var setValue = function setValue(item) {
    var value = {
      address_line1: '',
      address_line2: '',
      postal_code: '',
      locality: '',
      dependent_locality: '',
      administrative_area: '',
      country_code: 'NL'
    };
    if (item.type === 'woonplaats') {
      value.locality = item.woonplaats;
      value.dependent_locality = item.gemeente;
    }
    setFieldValue(webformKey, value);
  };
  function validation(value) {
    var error;
    if (required && !value) {
      error = requiredError || t(['webform.components.address_autocomplete.required', 'webform.required', 'webform_required']);
    }
    if (!error) {
      fieldOverrides.entrySeq().forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          requirement = _ref2[1];
        if (requirement === 'required' && (!value[key] || value[key] === '')) {
          error = requiredError || t(['webform.components.address_autocomplete.required', 'webform.required', 'webform_required']);
        }
      });
    }
    return error;
  }
  return /*#__PURE__*/React.createElement(GenericFormElement, {
    className: wrapperClassNames,
    title: title,
    required: required,
    description: description,
    fieldName: webformKey,
    touched: props.touched[webformKey],
    error: props.errors[webformKey]
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
    name: webformKey,
    validate: validation
  }, function (_ref3) {
    var field = _ref3.field,
      form = _ref3.form;
    return /*#__PURE__*/React.createElement("input", _extends({}, field, {
      type: "hidden"
    }));
  }), /*#__PURE__*/React.createElement(ApiAutocomplete, {
    endpoint: "".concat(API_URL, "/api/address-autocomplete"),
    onSelectItem: function onSelectItem(item) {
      setValue(item);
    },
    renderItem: function renderItem(item, active) {
      var classes = className({
        active: active
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classes
      }, item.name, item.type === 'gemeente' && /*#__PURE__*/React.createElement("div", null, " ", t(['webform.components.address_autocomplete.township', 'webform.township', 'webform_township'])));
    }
  })));
};
export default WebformAddressAutocomplete;